import { TypographyVariant, useTheme } from "../theme";
import { ShimmerEffectBox, ShimmerEffectBoxProps } from "./ShimmerEffectBox";

export interface ShimmerEffectTextProps extends Omit<
  ShimmerEffectBoxProps,
  "height" | "fontSize"
> {
  typographyVariant: TypographyVariant;
}

/**
 * ShimmerEffectTextは、ShimmerEffectBoxの薄いラッパーです。
 * 一行の文章のローディング表示を、Typographyのvariantに基づいて生成します。
 *
 * widthにch単位を利用すると、文字数に合わせて幅を調整することができるので利用をおすすめします。
 */
export const ShimmerEffectText = ({
  typographyVariant,
  ...rest
}: ShimmerEffectTextProps) => {
  const theme = useTheme();

  const typography = theme.typography[typographyVariant];
  const fontSize = typography.fontSize;
  const height = fontSize * typography.lineHeight;

  return (
    <ShimmerEffectBox
      {...rest}
      height={height}
      fontSize={fontSize}
      css={typography}
    />
  );
};
